import React from "react";
import { Modal, DropdownItem, Button, FormGroup, Input } from "reactstrap";

function AuthorSelection(props) {
  let {} = props;

  return (
    <Modal
      className="modal-dialog-centered modal-sm"
      isOpen={props.operationNewModal}
      toggle={() => props.toggleNewModal()}
    >
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => props.toggleNewModal()}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        {/* {props.sub.errorMsg} */}
        <label className="form-control-label">選擇分類</label>
        <div
          className="mb-3"
          style={{
            border: "1px solid",
            borderColor: "#cccccc",
            borderRadius: "4px",
          }}
        >
          <div className="d-flex justify-content-around py-4">
            <div className="px-2 py-1" style={{ flex: 1 }}>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-102"
                  id="check-102"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(102) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={102}
                />
                <label className="custom-control-label" htmlFor="check-102">
                  春節遊園會
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-103"
                  id="check-103"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(103) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={103}
                />
                <label className="custom-control-label" htmlFor="check-103">
                  麥當勞教育展
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-104"
                  id="check-104"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(104) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={104}
                />
                <label className="custom-control-label" htmlFor="check-104">
                  其他活動
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-107"
                  id="check-107"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(107) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={107}
                />
                <label className="custom-control-label" htmlFor="check-107">
                  商家信息
                </label>
              </div>
            </div>

            <div className="px-2 py-1" style={{ flex: 1 }}>
              {" "}
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-111"
                  id="check-111"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(111) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={111}
                />
                <label className="custom-control-label" htmlFor="check-111">
                  健康養生
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-106"
                  id="check-106"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(106) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={106}
                />
                <label className="custom-control-label" htmlFor="check-106">
                  促銷活動
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-109"
                  id="check-109"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(109) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={109}
                />
                <label className="custom-control-label" htmlFor="check-109">
                  美食
                </label>
              </div>
            </div>
            <div className="px-2 py-1" style={{ flex: 1 }}>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-112"
                  id="check-112"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(112) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={112}
                />
                <label className="custom-control-label" htmlFor="check-112">
                  娛樂
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-113"
                  id="check-113"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(113) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={113}
                />
                <label className="custom-control-label" htmlFor="check-113">
                  旅遊
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-159"
                  id="check-159"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(159) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={159}
                />
                <label className="custom-control-label" htmlFor="check-159">
                  體育
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-110"
                  id="check-110"
                  type="checkbox"
                  checked={
                    props.data.category_ids
                      ? props.data.category_ids.indexOf(110) !== -1
                      : false
                  }
                  onChange={(e) => props.handleCheckBoxChange(e)}
                  value={110}
                />
                <label className="custom-control-label" htmlFor="check-110">
                  房地產
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={() => props.toggleNewModal()}
          >
            取消
          </Button>
          <Button
            color="default"
            type="button"
            onClick={() => props.submitArticle()}
          >
            新文章
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default AuthorSelection;
